import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, SmartphoneNfc, Store, ShoppingCart, ArrowRight, Receipt, Mail } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <CreditCard className="w-10 h-10 text-zumpago-red" data-id="element-327" />,
    title: 'Botones o Pasarelas de Pago',
    description: 'Acepta tarjetas de crédito, débito, prepago y transferencias bancarias con la mayor tasa de aprobación del mercado. Incluye integración con las principales plataformas de comercio electrónico.',
    features: ['Checkout personalizado', 'Tokenización de tarjetas', 'Traspaso de comisiones del medio de pago al Cliente (opcional y configurable)', 'Integración E-commerce (Shopify, WooCommerce, VTEX)', 'Prevención de fraude nativa', 'Conciliación automática']
  }, {
    icon: <Store className="w-10 h-10 text-zumpago-red" data-id="element-328" />,
    title: 'Portal de Pagos',
    description: 'Servicio ofrecido a las empresas de servicios para que sus clientes puedan pagar sus cuentas, cuotas, mensualidades, etc. Incluye la adaptación y configuración de un sitio web para el proceso de recaudación, con el look & feel de la empresa de servicios, el cual puede ser vinculado a su sitio web corporativo.',
    features: []
  }, {
    icon: <Receipt className="w-10 h-10 text-zumpago-red" data-id="element-329" />,
    title: 'Pago de Cuentas o Servicios',
    description: 'La red de recaudación de ZUMPAGO es un servicio que permite el pago de cuentas de productos y servicios utilizando los medios de pago disponibles, con la comodidad de tener todas las cuentas agrupadas en un solo lugar.',
    features: ['Rápida integración con empresas de servicios', 'Agrupación de cuentas a pagar por el cliente', 'Estadísticas y gestión de pagos para clientes y comercios', 'Múltiples canales para pagos (Cajas propias y de comercios, Kioscos, Portal Web de pagos, App y otros)']
  }, {
    icon: <SmartphoneNfc className="w-10 h-10 text-zumpago-red" data-id="element-330" />,
    title: 'Recarga de Prepagos',
    description: 'A través de ZUMPAGO se puede realizar la recarga de productos prepago de celulares, TV, internet u otros, recibiendo la confirmación de forma inmediata.',
    features: ['Trabajamos con todas las compañías', 'Se puede recargar el monto que se desee', 'Total seguridad y confiabilidad para las transacciones de recarga']
  }, {
    icon: <ShoppingCart className="w-10 h-10 text-zumpago-red" data-id="element-331" />,
    title: 'Venta de Productos Masivos',
    description: 'En ZUMPAGO podemos realizar la recaudación de Seguros, Tickets de Cine o Eventos, etc.',
    features: []
  }, {
    icon: <CreditCard className="w-10 h-10 text-zumpago-red" data-id="element-332" />,
    title: 'Venta y Recarga de Servicios de Terceros',
    description: 'Nuestra red permite procesar y recaudar Monederos de Transporte, Gift Card u otros.',
    features: []
  }, {
    icon: <CreditCard className="w-10 h-10 text-zumpago-red" data-id="element-333" />,
    title: 'Links de Pago',
    description: 'Genera enlaces de pago personalizados para compartir por correo, WhatsApp, redes sociales o cualquier canal digital. Ideal para cobrar sin necesidad de un sitio web.',
    features: []
  }, {
    icon: <CreditCard className="w-10 h-10 text-zumpago-red" data-id="element-334" />,
    title: 'Suscripción de Pagos Recurrentes',
    description: 'Servicio ofrecido a empresas para que sus clientes puedan suscribir sus pagos de manera recurrente usando una Tarjeta de Crédito o Débito.',
    features: ['Portal de suscripción con el look & feel de la empresa', 'API rest de suscripción']
  }, {
    icon: <Mail className="w-10 h-10 text-zumpago-red" data-id="element-335" />,
    title: 'Envío Email con Link de Pago',
    description: 'Servicio ofrecido a empresas para enviar de manera individual o de manera masiva emails al cliente con link de pago que llevan directo al monto y selección de medios de pagos.',
    features: ['Recordatorio de vencimiento', 'Cobranza', 'Campañas']
  }, {
    icon: <Store className="w-10 h-10 text-zumpago-red" data-id="element-336" />,
    title: 'Portal de Vendedores',
    description: 'Servicio ofrecido a empresas que poseen fuerza de venta y requieren de una herramienta para poder realizar procesos de venta en terreno.',
    features: ['Ingreso de venta y generación QR de pago', 'Envío link de pago por email', 'Notificación en línea']
  }, {
    icon: <CreditCard className="w-10 h-10 text-zumpago-red" data-id="element-337" />,
    title: 'Pagos Masivos',
    description: 'Servicio ofrecido a empresas que deseen realizar pagos a múltiples cuentas y servicios en una sola transacción de pago.',
    features: []
  }, {
    icon: <SmartphoneNfc className="w-10 h-10 text-zumpago-red" data-id="element-338" />,
    title: 'Desarrollo de otros productos y servicios transaccionales a pedido',
    description: 'Dada la flexibilidad y adaptabilidad de ZUMPAGO, podemos desarrollar productos y/o servicios transaccionales a pedido. Somos el aliado estratégico que facilita tus procesos.',
    features: []
  }];
  return <section id="servicios" className="py-24 bg-zumpago-dark text-white" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-341">
          <div className="max-w-2xl" data-id="element-342">
            <h2 className="text-lg font-bold text-zumpago-red tracking-wider uppercase mb-3" data-id="element-343">
              Productos y Servicios
            </h2>
            <h3 className="text-4xl font-bold mb-6" data-id="element-344">
              Soluciones completas para cada modelo de negocio
            </h3>
            <p className="text-lg text-gray-400" data-id="element-345">
              Ya sea que requieras recaudar en línea o fuera de línea, en
              plataformas web, apps, cajas presenciales, kioskos de
              autoatención, por redes sociales u otro canal, tenemos la
              herramienta exacta para procesar tus pagos de manera eficiente, y
              sin contracargos ni reversas, haciendo la gestión de pagos una
              tarea sin complicaciones.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-346">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-800/50 border border-gray-700 rounded-3xl p-8 hover:bg-gray-800 transition-colors" data-id="element-347">
              <div className="flex flex-col sm:flex-row gap-6" data-id="element-348">
                <div className="flex-shrink-0" data-id="element-349">
                  <div className="w-20 h-20 rounded-2xl bg-gray-900 flex items-center justify-center border border-gray-700" data-id="element-350">
                    {service.icon}
                  </div>
                </div>
                <div data-id="element-351">
                  <h4 className="text-2xl font-bold mb-3" data-id="element-352">{service.title}</h4>
                  <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-353">
                    {service.description}
                  </p>
                  <ul className="space-y-2" data-id="element-354">
                    {service.features.map((feature, fIndex) => <li key={fIndex} className="flex items-center gap-2 text-sm text-gray-300" data-id="element-355">
                        <div className="w-1.5 h-1.5 rounded-full bg-zumpago-red" data-id="element-356"></div>
                        {feature}
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}